



















// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import AgenciesTable from '../components/AgenciesTable.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    Tiles,
    CardWidget,
    CardComponent,
    AgenciesTable,
  },
})
export default class AgencyList extends Vue {
  public get titleStack(): string[] {
    return ['Admin', 'Agences'];
  }
}
